<div [ngClass]="['filters', resourcesCssService.responsiveClass()]">
  <div class='header'>
    <h2 (click)='toggleExpanded()'>Filters</h2>
    <button class='clear-filters' [hidden]='filters.selectedFilterItems().length === 0' (click)='clearFilters()'>Clear Filters</button>
    <p (click)='toggleExpanded()'>{{ filters.numResults >= 0 ? filters.numResults + ' Results' : ''}}</p>

    <div class='toggle-column' *ngIf="resourcesCssService.responsiveClass() !== ''">
      <button (click)='toggleExpanded()'><i [ngClass]="isExpanded ? 'mt-arrow-up': 'mt-arrow-down'"></i></button>
    </div>
  </div>

  <ng-container  *ngIf='showList()'>
    <div class='separator'></div>
    <div class='section' *ngFor='let section of filters.sections'>
      <ng-container *ngIf='section.items.length > 0'>
        <label>{{ section.title }}</label>
        <div class='list'>
          <ng-container *ngFor='let item of section.items'>
            <button class='pill' [ngClass]='itemClass(item)' (click)='toggleFilter(section, item)'>{{item.title}}</button>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
